// Element ids of the panels that controls name in `aria-controls` (ui.md 3.2).

export const BROWSER_PANEL_ID = 'browser-panel'
export const SIDE_PANEL_ID = 'side-panel'
